<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <div class="title-box">
          <el-image :src="cheImage" class="title-label"></el-image>
          申请信息
        </div>
        <div class="order-detail-box">
          <div class="label-val">
            <div class="label-1">申请时间</div>
            <div class="value-1">{{ form.applyTime }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">申请人姓名</div>
            <div class="value-1">{{ form.ownerName }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">手机号码</div>
            <div class="value-1">{{ form.phone }}</div>
          </div>
        </div>
        <div class="title-box">
          <el-image :src="cheImage" class="title-label"></el-image>
          关联订单信息
        </div>
        <div class="related-orders">
          <custom-table :data="form.orders" :column="tableColumn" :showPagination="false">
            <template v-slot:pointList="{ row }">
              {{row.pointList[0].cityName}}{{row.pointList[0].districtName}}
            </template>
            <template v-slot:orderId="{ row }">
              {{row.pointList[row.pointList.length-1].cityName}}{{row.pointList[row.pointList.length-1].districtName}}
            </template>
          </custom-table>
        </div>
        <div class="title-box">
          <el-image :src="cheImage" class="title-label"></el-image>
          发票信息
        </div>
        <el-row class="invice-info">
          <el-col :span="12">
            <span class="label">发票类型：</span>
            <span class="value">
              <span v-if="form.invoiceType === 1">个人</span>
              <span v-if="form.invoiceType === 2">企业</span>
            </span>
          </el-col>
          <el-col :span="12">
            <span class="label">开票金额：</span>
            <span class="value">{{ form.amount }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">购方名称：</span>
            <span class="value">{{ form.buyerName || "-" }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">购方税号：</span>
            <span class="value">{{ form.buyerTaxNumber || "-" }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">公司地址：</span>
            <span class="value">{{ form.companyAddress || "-" }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">公司电话：</span>
            <span class="value">{{ form.companyPhone || "-" }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">公司开户行：</span>
            <span class="value">{{ form.bankName || "-" }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">开户行账号：</span>
            <span class="value">{{ form.bankCard || "-" }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">备注：</span>
            <span class="value">{{ form.remark || "-" }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">接收发票邮箱：</span>
            <span class="value">{{ form.acceptEmail || "-" }}</span>
          </el-col>
        </el-row>

        <template v-if="!isDetail">
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>
            开票处理
          </div>
          <el-row :gutter="20">
            <el-form ref="form" :model="form" :rules="rules" label-position="top">
              <el-col :span="24">
                <el-form-item label="处理凭证：" prop="fileIds">
                  <upload-files2 v-model="form.fileIds"></upload-files2>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </template>
        <template v-else>
          <div v-if="form.invoiceStatus === 1">
            <div class="title-box">
              <el-image :src="cheImage" class="title-label"></el-image>
              处理信息
            </div>
            <el-row class="common-info-box">
              <el-col :span="12">
                <span class="label">操作人：</span>
                <span class="value">{{ form.handleUsername }}</span>
              </el-col>
              <el-col :span="12">
                <span class="label">操作时间：</span>
                <span class="value">{{ form.handleTime }}</span>
              </el-col>
              <el-col :span="24">
                <span class="label">处理凭证：</span>
                <span class="value">
                  <div class="common-image-box">
                    <el-image
                      v-for="(item, index) in form.fileIds"
                      :key="index"
                      :src="getFileUrl(item)"
                      class="common-image"
                      :preview-src-list="[getFileUrl(item)]"></el-image>
                  </div>
                </span>
              </el-col>
            </el-row>
          </div>
        </template>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import {detailInfo, getPage, handleInvoice, setReal} from "./api";
import UploadFiles2 from "@/components/UploadFiles4.vue";
import CustomTable from "@/components/CustomTable.vue";
import tableMixin from "@/mixin/tableMixin";

import { getFileUrl } from "@/utils/tool";
export default {
  name: "AddOrEdit",
  mixins: [tableMixin],
  components: {
    CustomTable,
    UploadFiles2,
    DialogContainer,
  },
  data() {
    return {
      getTableMethod: getPage,
      isImmediatelyGetData: false,
      cheImage: require("@/assets/imgs/title.png"),
      imageUrl: require("@/assets/imgs/bg.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "60%",
        show: false,
        title: "开票处理",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        fileIds: [],
      },
      rules: {
        fileIds: [{ required: true, message: "处理凭证不能为空" }],
      },
      isDetail: false,
      tableColumn: [
        {
          label: "订单编号",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "装货地",
          prop: "pointList",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "卸货地",
          prop: "pointList",
          scopeStatus: true,
          align: "left",
          show: false,
        },
        {
          label: "卸货地",
          prop: "orderId",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "货物名称",
          prop: "cargoName",
          align: "left",
          show: true,
        },
        {
          label: "订单金额(不含税)",
          prop: "payableFee",
          align: "left",
          show: true,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    getFileUrl,
    init(title, isDetail, row) {
      this.dialogObj.title = title;
      this.isDetail = isDetail;
      if (this.isDetail) {
        this.dialogObj.confirmFn = "";
      } else {
        this.dialogObj.confirmFn = this.submitForm;
      }
      if (!!row) {
        this.getDetails(row.invoiceId)
      }
      this.dialogObj.show = true;
    },
    getDetails(invoiceId) {
      detailInfo(invoiceId)
          .then((res) => {
            this.dialogObj.btnLoading = false;
            if (res.code === 200) {
              this.form = res.data;
            }
          })
          .catch((e) => {
            this.dialogObj.btnLoading = false;
          });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const fileIds = this.form.fileIds
              .map(item => item.fileId);
          const par = {
            invoiceId: this.form.invoiceId,
            fileIds: fileIds,
          };
          handleInvoice(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("处理成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.12rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .common-image-box {
    margin-bottom: 0;
    margin-top: 0.04rem;
  }
  .invice-info {
    line-height: 0.24rem;
    margin-bottom: 0.2rem;
  }
  .related-orders {
    background: #f7f8fb;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
  }
}
</style>
